import ReportLayout from 'src/pages/Reports/Common/report/ReportLayout';
import ReportDetails from 'src/pages/Reports/Common/report/ReportDetails';

const RoadReport = () => (
  <ReportLayout title="Road Opening Report">
    <ReportDetails
      title="Report Details"
      downloadEndpoint="road_permit_application/download"
    />
  </ReportLayout>
);

export default RoadReport;
